import { useMachine } from "@xstate/react";
import { useCallback, useMemo } from "react";
import { CategoryDetailResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { BreadcrumbNavigationItem } from "../components/breadcrumbs";
import { CategoryDetailMachine } from "../machines/category_detail_machine";

type CategoryDetailControls = {
  categoryIsLoading: boolean;
  breadcrumbs: BreadcrumbNavigationItem[] | null;
  category: CategoryDetailResult | null;
  retryCategoryLoad?: () => void;
};

export const useCategoryDetail = (
  baseUrl: string,
  categoryId: number
): CategoryDetailControls => {
  const [state, send] = useMachine(CategoryDetailMachine, {
    context: {
      baseUrl,
      categoryId,
    },
  });

  const retryCategoryLoad = useCallback(() => {
    send("RETRY");
  }, [send]);

  const category = state.context.category;

  const breadcrumbs: BreadcrumbNavigationItem[] | null = useMemo(
    () =>
      category === undefined
        ? null
        : [...category.breadcrumbs].map((breadcrumb) => ({
            path: breadcrumb?.linkPath,
            title: breadcrumb?.shortPluralName,
            position: breadcrumb?.position,
          })),
    [categoryId, category]
  );

  if (state.matches("loadingDetail")) {
    return {
      categoryIsLoading: true,
      breadcrumbs: null,
      category: null,
    };
  }

  if (state.matches("displayed")) {
    return {
      categoryIsLoading: false,
      breadcrumbs,
      category: category as CategoryDetailResult,
    };
  }

  return {
    retryCategoryLoad,
    categoryIsLoading: false,
    breadcrumbs: null,
    category: null,
  };
};
